export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";